import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'row']

  filter() {
    const query = this.inputTarget.value.toLowerCase().trim()

    this.rowTargets.forEach(row => {
      const name = row.dataset.userName || ''
      const match = !query || name.includes(query)
      row.classList.toggle('hidden', !match)
    })
  }
}
